<template>
    <div ref="root">
        <template v-if="embedded">
            <page-editor-component></page-editor-component>
        </template>
        <template v-else>
            <header-component></header-component>
            <side-navigation-component></side-navigation-component>
            <router-view></router-view>
            <vue-progress-bar></vue-progress-bar>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import M from 'moment';
import V from 'voca';
import { singular, plural } from 'pluralize';
import VueProgressBar from 'vue-progressbar';

import HeaderComponent from './HeaderComponent';
import SideNavigationComponent from './SideNavigationComponent';
import PageEditorComponent from '72cms-ui/components/PageEditorComponent';

import {
    Modal, Card, Navbar, FormGroup, FormInput, InputGroup, Tabs,
    FormSelect, FormCheckbox, Pagination, Popover, Table, Collapse
} from 'bootstrap-vue/es/components';

Vue.use(Modal);
Vue.use(Card);
Vue.use(Navbar);
Vue.use(FormGroup);
Vue.use(FormInput);
Vue.use(InputGroup);
Vue.use(FormSelect);
Vue.use(FormCheckbox);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Collapse);

const options = {
    color: '#00a6ff',
    failedColor: '#ffc107',
    transition: {
        speed: '2s',
        opacity: '0.6s',
        termination: 2000
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, options)

export default {
    data() {

        Vue.set(Vue.prototype, '_', _);
        Vue.set(Vue.prototype, '__', this.getHelpers('formatString'));

        Vue.set(Vue.prototype, 'config', this.getHelpers('getConfig'));
        Vue.set(Vue.prototype, 'getConfig', this.getHelpers('getConfig'));
        Vue.set(Vue.prototype, 'helpers', this.getHelpers);

        _.mixin({
            singular, plural,
            datetime: M,
            format: this.getHelpers('formatString'),
            str: this.getHelpers('formatString'),
            setting: this.getHelpers('getSetting'),
            imgPath: this.getHelpers('getImagePath'),
            assetPath: this.getHelpers('getAssetPath'),
            dispatch: this.getHelpers('dispatchEvent'),
            subscribe: this.getHelpers('subscribeEvent'),
            unsubscribe: this.getHelpers('unsubscribeEvent'),
        });

        return {
            loading: false,
            embedded: _.includes(['/admin/_embed_', '/admin/_embed_/'], window.location.pathname),
        }
    },

    props: ['getHelpers'],

    components: {
        SideNavigationComponent,
        HeaderComponent,
        PageEditorComponent,
    },

    created () {
        this.$Progress.start();
        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach((to, from, next) => {
            //  does the page we want to go to have a meta.progress object
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress;
                // parse meta tags
                this.$Progress.parseMeta(meta);
            }
            //  start the progress bar
            if ((to.path != from.path) || !_.isEqual(to.query, from.query)) {
                this.$Progress.start();
            }
            //  continue to next page
            next();
        })

        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach((to, from) => {
            //  finish the progress bar
            if ((to.path != from.path) || !_.isEqual(to.query, from.query)) {
                this.$Progress.finish();
            }
        })
    },

    mounted() {
        console.log('Component mounted.')

        const dispatchEvent = this.getHelpers('dispatchEvent');
        window.addEventListener('keydown', (e) => dispatchEvent('key.down', e));
        window.addEventListener('keyup', (e) => dispatchEvent('key.up', e));
        this.$Progress.finish();
    },

    computed: {

    },

    methods: {
        processing() {
            this.loading = true;
        },
        idle() {
            this.loading = false;
        },
        onDrop(e) {
            e.preventDefault();
            e.stopPropagation();
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/MainComponent.vue